(function () {
  if (window.__relatedProductsMobileDotsReady) return;
  window.__relatedProductsMobileDotsReady = true;

  function initRoot(root) {
    if (!root || root.dataset.initialized === 'true') return;

    var viewport = root.querySelector('[data-rpm-viewport]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-rpm-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.rpm__dot'));

    if (!viewport || slides.length < 2 || !dots.length) {
      root.dataset.initialized = 'true';
      return;
    }

    function getSlideLeft(slide) {
      return slide.offsetLeft - slides[0].offsetLeft;
    }

    function getCurrentIndex() {
      var closestIndex = 0;
      var closestDistance = Infinity;

      slides.forEach(function (slide, index) {
        var distance = Math.abs(getSlideLeft(slide) - viewport.scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function updateDots() {
      var index = getCurrentIndex();

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function snapToClosest() {
      var index = getCurrentIndex();
      viewport.scrollTo({
        left: getSlideLeft(slides[index]),
        behavior: 'smooth'
      });
      updateDots();
    }

    var ticking = false;
    viewport.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(function () {
        updateDots();
        ticking = false;
      });
    }, { passive: true });

    window.addEventListener('resize', updateDots);
    updateDots();
    root.dataset.initialized = 'true';

    var startX = 0;
    var startY = 0;
    var deltaX = 0;
    var deltaY = 0;
    var touching = false;

    viewport.addEventListener('touchstart', function (event) {
      if (!event.touches || !event.touches.length) return;
      touching = true;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      deltaX = 0;
      deltaY = 0;
    }, { passive: true });

    viewport.addEventListener('touchmove', function (event) {
      if (!touching || !event.touches || !event.touches.length) return;
      deltaX = event.touches[0].clientX - startX;
      deltaY = event.touches[0].clientY - startY;
    }, { passive: true });

    viewport.addEventListener('touchend', function () {
      if (!touching) return;
      touching = false;

      if (Math.abs(deltaX) > 24 && Math.abs(deltaX) > Math.abs(deltaY)) {
        window.setTimeout(snapToClosest, 80);
      }
    }, { passive: true });
  }

  function initSection(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.rpmObserverInitialized === 'true') return;

    function boot() {
      var root = sectionRoot.querySelector('[data-rpm-root]');
      initRoot(root);
    }

    boot();

    var recommendationsNode = sectionRoot.querySelector('[data-related-products-container]');
    if (recommendationsNode) {
      var observer = new MutationObserver(boot);
      observer.observe(recommendationsNode, {
        childList: true,
        subtree: true
      });
    }

    sectionRoot.dataset.rpmObserverInitialized = 'true';
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-related-products-custom]').forEach(initSection);
  }

  initAll();
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
